module.exports = __webpack_public_path__ + "static/media/beardedman.3bd8e0c4.svg";